import { BORDER_RADIUS } from "../../utils/constants";
import { ButtonWrapperProps } from "./Button.types";
import { generateButtonStyles } from "../../utils";
import styled from "@emotion/styled";

export const ButtonWrapper = styled.button<ButtonWrapperProps>`
  appearance: none;
  border: none;
  cursor: pointer;
  border-radius: ${BORDER_RADIUS} !important;
  padding: 15px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  // gap: 8px;
  height: 48px;
  width: 100%;
  ${(props) => generateButtonStyles(props)}
  .left-icon {
    margin-right: 8px;
  }

  .right-icon {
    margin-left: 16px;
  }
`;
